// import { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Box, TextField, Button, Container, Typography, Grid, AppBar, Toolbar, Paper, CircularProgress, Divider } from '@mui/material';
// import CitySearchInput from "../components/CitySearchInput";
// import FloatingLabelInput from "../components/FloatingLabelInput";
// import { useAuth } from '../context/AuthContext';

// export default function RegisterCompany({ connectionString }) {
//     // Inside RegisterCompany component:
//     const location = useLocation();
//     const pendingFromLogin = location.state?.pendingUser;
//     const pendingPassword = location.state?.password;
//     const userName = pendingFromLogin.UserName;
//     const Uid = pendingFromLogin.UserId;
//     const AppRegID = pendingFromLogin?.AppRegID || null;
//     console.log(pendingPassword, userName, Uid);
//     const { user, selectedCompany, loading, login } = useAuth(); // ← YOU SAID NEVER CHANGE THIS
//     const path = connectionString;
//     const navigate = useNavigate();

//     // === FIXED: Get user data properly from pending login or current user ===
//     const pendingLogin = JSON.parse(localStorage.getItem("pendingCompanyUser") || "{}");
//     const currentUser = pendingLogin.user || user;
//     const userId = currentUser?.UserId || null;
//     // const AppRegID = currentUser?.AppRegID || null;
//     const userPassword = pendingLogin.password || currentUser?.Password || '';

//     // === ALL YOUR STATES (unchanged) ===
//     const [companyName, setCompanyName] = useState("");
//     const [address, setAddress] = useState("");
//     const [area, setArea] = useState("");
//     const [city, setCity] = useState("");
//     const [stateField, setStateField] = useState("");
//     const [stateCode, setStateCode] = useState("");
//     const [pincode, setPincode] = useState("");
//     const [country, setCountry] = useState("India");
//     const [contactPerson, setContactPerson] = useState("");
//     const [mobileno, setMobileno] = useState("");
//     const [website, setWebsite] = useState("");
//     const [emailId, setEmailId] = useState("");
//     const [currency, setCurrency] = useState("");
//     const [gstInno, setGstInno] = useState("");
//     const [adharno, setAdharno] = useState("");
//     const [tanno, setTanno] = useState("");
//     const [panno, setPanno] = useState("");
//     const [msmeno, setMsmeno] = useState("");
//     const [cinno, setCinno] = useState("");
//     const [ielicno, setIelicno] = useState("");
//     const [postalAddress, setPostalAddress] = useState("");
//     const [branchId, setBranchId] = useState("");
//     const [groupOfCompanyId, setGroupOfCompanyId] = useState("");

//     const [gstLookupLoading, setGstLookupLoading] = useState(false);
//     const [gstValid, setGstValid] = useState(true); // ← THIS WAS MISSING
//     const [gstError, setGstError] = useState("");
//     const [errorMessage, setErrorMessage] = useState("");
//     const [successMessage, setSuccessMessage] = useState("");

//     // === FINAL SUBMIT — FIXED EVERYTHING ===
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setErrorMessage("");
//         setSuccessMessage("");

//         if (!companyName.trim() || !contactPerson.trim() || !mobileno.trim() || !emailId.trim()) {
//             setErrorMessage("Company Name, Contact Person, Email and Mobile are required.");
//             return;
//         }

//         const payload = {
//             AppRegID,
//             companyName: companyName.trim(),
//             address: address.trim() || null,
//             area: area.trim() || null,
//             city: city.trim() || null,
//             state: stateField.trim() || null,
//             stateCode: stateCode.trim() || null,
//             pincode: pincode ? Number(pincode) : null,
//             country: country.trim() || "India",
//             contactPerson: contactPerson.trim(),
//             mobileno: mobileno.trim(),
//             website: website.trim() || null,
//             emailId: emailId.trim(),
//             currency: currency.trim() || null,
//             userName: userName,
//             password: pendingPassword,
//             gstInno: gstInno.trim() || null,
//             adharno: adharno.trim() || null,
//             tanno: tanno.trim() || null,
//             panno: panno.trim() || null,
//             msmeno: msmeno.trim() || null,
//             cinno: cinno.trim() || null,
//             ielicno: ielicno.trim() || null,
//             postalAddress: postalAddress.trim() || null,
//             branchId: branchId || null,
//             groupOfCompanyId: groupOfCompanyId || null,
//             addUserId: Uid
//         };

//         console.log("Payload: ", payload);

//         try {
//             const res = await axios.post(`${path}/api/companyMaster`, payload);

//             if (res.data.success) {
//                 localStorage.removeItem("pendingCompanyUser");

//                 const companyId = res.data.companyId;
//                 const companies = res.data.companies || [{ CompId: companyId, companyName }];

//                 // === UPDATE AUTH CONTEXT PROPERLY ===
//                 const updatedUser = {
//                     ...currentUser,
//                     CompId: companyId,
//                     companyId: companyId
//                 };

//                 login(updatedUser, companies);

//                 setSuccessMessage("Company registered successfully!");
//                 setTimeout(() => navigate("/BestCRM"), 1000);
//             } else {
//                 setErrorMessage(res.data.message || "Registration failed");
//             }
//         } catch (err) {
//             setErrorMessage(err.response?.data?.message || "Server error. Try again.");
//         }
//     };

//     // === GST LOOKUP — FULLY WORKING ===
//     const Fn_HandleGSTBlur = async () => {
//         const gst = gstInno.trim();
//         if (gst.length !== 15) return;

//         const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
//         if (!regex.test(gst)) {
//             setGstError("Invalid GST format");
//             return;
//         }

//         setGstLookupLoading(true);
//         setGstError("");

//         try {
//             const { data } = await axios.get(`${path}/api/gst-lookup`, { params: { searchGstin: gst } });
//             const d = data.data || {};

//             setCompanyName(d.clientName || "");
//             setContactPerson(d.contactPerson || "");
//             setAddress(d.address || "");
//             setCity(d.city || "");
//             setArea(d.landMark || d.street || "");
//             setPincode(d.PinCode ? String(d.PinCode) : "");
//             setCountry(d.Country || "India");
//             setMobileno(d.mobileNo || "");
//             setEmailId(d.emailId || "");
//             setStateField(d.state || "");
//             setStateCode(d.stateCode || gst.slice(0, 2));
//         } catch (err) {
//             setGstError("Invalid or inactive GSTIN");
//             // Clear fields on error
//             setCompanyName(""); setAddress(""); setCity(""); setArea(""); setPincode(""); setMobileno(""); setEmailId("");
//         } finally {
//             setGstLookupLoading(false);
//         }
//     };

//     if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 20 }}><CircularProgress /></Box>;

//     return (
//         <Box>
//             {/* Ribbon Header */}
//             <AppBar position="static" sx={{ bgcolor: "white", boxShadow: 3 }}>
//                 <Toolbar>
//                     <Container maxWidth="md" sx={{ display: 'flex', justifyContent: 'center' }}>
//                         <Box component="img" src="/Nexon_CRM_Final.svg" alt="Logo" sx={{ height: 38, }} />
//                     </Container>
//                 </Toolbar>
//             </AppBar>

//             {/* Main Registration Content */}
//             <Box sx={{ p: 4 }}>
//                 <Paper sx={{ maxWidth: 800, mx: "auto", p: 4 }} elevation={3}>
//                     <Typography variant="h4" gutterBottom textAlign="center">
//                         Company Registration
//                     </Typography>

//                     <Divider sx={{ my: 2 }} />

//                     <form onSubmit={handleSubmit}>
//                         {/* Company Registration Section */}
//                         <Grid container spacing={2}>
//                             {/* GST IN Field with Lookup */}
//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="GST IN *"
//                                     variant="outlined"
//                                     fullWidth
//                                     value={gstInno}
//                                     onChange={(e) => {
//                                         const val = e.target.value.toUpperCase();
//                                         if (/^[A-Z0-9]{0,15}$/.test(val)) {
//                                             setGstInno(val);
//                                             setGstError("");
//                                             setGstValid(true);
//                                         }
//                                     }}
//                                     onBlur={Fn_HandleGSTBlur}
//                                     error={!!gstError}
//                                     helperText={gstError || (gstLookupLoading ? "Looking up..." : "15-digit GSTIN")}
//                                     size="small"
//                                     inputProps={{ maxLength: 15 }}
//                                     sx={{ '& .MuiInputBase-root': { height: 38 } }}
//                                     InputProps={{
//                                         endAdornment: gstLookupLoading && (
//                                             <CircularProgress size={20} />
//                                         ),
//                                     }}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Company Name *" variant="outlined" fullWidth value={companyName} onChange={(e) => setCompanyName(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Email ID" variant="outlined" fullWidth value={emailId} onChange={(e) => setEmailId(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Aadhar No" variant="outlined" fullWidth value={adharno} onChange={e => setAdharno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                             </Grid>
//                             {/* OUTER: full-width item */}
//                             <Grid item xs={12} pt={2} pl={2}>
//                                 {/* INNER: container for the row of two halves */}
//                                 <Grid container spacing={2}>
//                                     {/* LEFT HALF */}
//                                     <Grid item xs={12} md={6}>
//                                         <TextField label="Address" multiline minRows={3.4} variant="outlined" fullWidth value={address} onChange={e => setAddress(e.target.value)} size="small"
//                                             sx={{
//                                                 '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 },
//                                                 '& .MuiOutlinedInput-inputMultiline': {
//                                                     padding: '8px 12px',
//                                                     minHeight: '80px',
//                                                 }
//                                             }}
//                                         />
//                                     </Grid>

//                                     {/* RIGHT HALF: also an item (xs=6) and a container for its own column */}
//                                     <Grid item xs={12} md={6} container direction="column" spacing={2}>
//                                         <Grid item>
//                                             <TextField label="PAN No" variant="outlined" fullWidth value={panno} onChange={(e) => setPanno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                                         </Grid>
//                                         <Grid item>
//                                             <TextField label="TAN No" variant="outlined" fullWidth value={tanno} onChange={e => setTanno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                         </Grid>
//                                     </Grid>
//                                 </Grid>
//                             </Grid>
//                             {/* If this block itself needs to be half width in an outer grid, wrap it: */}
//                             <Grid item xs={12} md={6}>
//                                 {/* Now define your two-column container */}
//                                 <Grid container spacing={1}>
//                                     <Grid item xs={6}>
//                                         <TextField label="Area" variant="outlined" fullWidth value={area} onChange={e => setArea(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                     </Grid>
//                                     <Grid item xs={6}>
//                                         <TextField
//                                             label="Pincode"
//                                             variant="outlined" fullWidth value={pincode} type="text" // Use text instead of number for strict control
//                                             onChange={(e) => {
//                                                 const val = e.target.value;
//                                                 // Allow only digits and max 6 characters
//                                                 if (/^\d{0,6}$/.test(val)) {
//                                                     setPincode(val);
//                                                 }
//                                             }}
//                                             size="small"
//                                             sx={{ '& .MuiInputBase-root': { height: 38 } }}
//                                             inputProps={{
//                                                 inputMode: 'numeric', // Shows numeric keypad on mobile
//                                                 pattern: '[0-9]*',    // Ensures digits only
//                                                 maxLength: 6,         // Enforced on text input
//                                             }}
//                                         />


//                                     </Grid>
//                                 </Grid>
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="MSME No" variant="outlined" fullWidth value={msmeno} onChange={(e) => setMsmeno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             {/* City Field using the custom CitySearchInput */}

//                             {/* City (25%) */}
//                             <Grid item xs={12} md={6}>
//                                 <CitySearchInput value={city} fullWidth size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} connectionString={connectionString}
//                                     onSelectCity={cityObj => {
//                                         setCity(cityObj.city);
//                                         setStateField(cityObj.state);
//                                         setStateCode(cityObj.stateCode);
//                                     }}
//                                 />
//                             </Grid>
//                             <Grid container xs={12} md={6} spacing={0.5} pl={2} pt={2}>
//                                 <Grid item xs={9.5} pt={1}>
//                                     <FloatingLabelInput label="State" name="state" type="text" value={stateField} disabled fullWidth size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                 </Grid>
//                                 <Grid item xs={2.5} pt={1}>
//                                     <FloatingLabelInput label="State Code" name="stateCode" type="text" value={stateCode} disabled fullWidth size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                 </Grid>
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Country" variant="outlined" fullWidth value={country} onChange={(e) => setCountry(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="CIN No" variant="outlined" fullWidth value={cinno} onChange={(e) => setCinno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Contact Person *" variant="outlined" fullWidth value={contactPerson} onChange={(e) => setContactPerson(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="I.E. No" variant="outlined" fullWidth value={ielicno} onChange={(e) => setIelicno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6} container direction="column" spacing={2}>
//                                 <Grid item>
//                                     <TextField label="Mobile Number *" variant="outlined" fullWidth value={mobileno} onChange={(e) => setMobileno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                                 </Grid>
//                                 <Grid item>
//                                     <TextField label="Website" variant="outlined" fullWidth value={website} onChange={(e) => setWebsite(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                                 </Grid>
//                             </Grid>
//                             {/* Optional Company Fields */}
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Postal Address" multiline
//                                     minRows={2.8} variant="outlined" fullWidth value={postalAddress} onChange={(e) => setPostalAddress(e.target.value)} sx={{
//                                         '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 },
//                                         '& .MuiOutlinedInput-inputMultiline': {
//                                             padding: '8px 12px',
//                                             minHeight: '80px',
//                                         }
//                                     }} />
//                             </Grid>
//                         </Grid>

//                         <Divider sx={{ my: 2 }} />

//                         {errorMessage && (<Typography variant="body2" color="error" sx={{ mt: 2 }}> {errorMessage} </Typography>)}
//                         {successMessage && (<Typography variant="body2" color="success.main" sx={{ mt: 2 }}> {successMessage} </Typography>)}

//                         <Box sx={{ mt: 4, textAlign: "center" }}>
//                             {/* Grid container for button layout */}
//                             <Grid container spacing={2} direction={{ xs: "column", sm: "row" }} justifyContent="center">
//                                 {/* Register Button */}
//                                 <Grid item>
//                                     <Button variant="contained" color="primary" type="submit"> Register </Button>
//                                 </Grid>
//                             </Grid>
//                         </Box>
//                     </form>

//                 </Paper>
//             </Box>
//         </Box>
//     );
// }















import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    Box, TextField, Button, Container, Typography, Paper, Divider, CircularProgress,
    Snackbar, Alert, InputAdornment, Grid,
    IconButton
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CitySearchInput from "../components/CitySearchInput";
import FloatingLabelInput from "../components/FloatingLabelInput";
import { useAuth } from '../context/AuthContext';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const RegisterCompany = ({ connectionString }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, loading, login } = useAuth();

    const pendingFromLogin = location.state?.pendingUser;
    const pendingPassword = location.state?.password;
    const userName = pendingFromLogin?.UserName;
    const Uid = pendingFromLogin?.UserId;
    const AppRegID = pendingFromLogin?.AppRegID || null;

    const pendingLogin = JSON.parse(localStorage.getItem("pendingCompanyUser") || "{}");
    const currentUser = pendingLogin.user || user;
    const userPassword = pendingLogin.password || currentUser?.Password || '';

    const [showPassword, setShowPassword] = useState({
        eway: false,
        einvoice: false,
    });

    const API = connectionString;

    const [formState, setFormState] = useState({
        gstInno: "", companyName: "", address: "", area: "", pincode: "", city: "", state: "", stateCode: "", country: "India",
        contactPerson: "", mobileno: "", emailId: "", website: "", adharno: "", tanno: "", panno: "", msmeno: "",
        cinno: "", ielicno: "", postalAddress: "", EWBUserName: "", EWBPassword: "", EIUserName: "", EIPassword: "", BkName1: "", BkBranch1: "", BkAcNo1: "", BkIFSCCode1: ""
    });

    const [gstLookupLoading, setGstLookupLoading] = useState(false);
    const [gstError, setGstError] = useState("");
    const [gstFetched, setGstFetched] = useState(false);

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState("");

    const [selectedCity, setSelectedCity] = useState(null);
    const [cityQuery, setCityQuery] = useState("");
    const [errors, setErrors] = useState({});

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const togglePassword = (key) => {
        setShowPassword((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        let errorMsg = "";

        // Account No
        if (name === "BkAcNo1" && value) {
            if (!/^\d+$/.test(value)) {
                errorMsg = "Only digits allowed";
            } else if (value.length < 9 || value.length > 18) {
                errorMsg = "9 to 18 digits required";
            }
        }

        // IFSC
        if (name === "BkIFSCCode1" && value) {
            const isValidLength = value.length === 11;
            const hasLetter = /[A-Za-z]/.test(value);
            const hasDigit = /\d/.test(value);
            const isAlphanumeric = /^[A-Za-z0-9]+$/.test(value);

            if (!isValidLength) {
                errorMsg = "Must be 11 characters";
            } else if (!isAlphanumeric) {
                errorMsg = "Only letters & digits allowed";
            } else if (!hasLetter || !hasDigit) {
                errorMsg = "Must contain letter & digit";
            }
        }

        setErrors(prev => ({
            ...prev,
            [name]: errorMsg
        }));
    };

    // const handleGstChange = (e) => {
    //     let value = e.target.value.toUpperCase();
    //     if (!/^[A-Z0-9]{0,15}$/.test(value)) return;
    //     setFormState(prev => ({ ...prev, gstInno: value }));
    //     setGstError("");
    //     setGstFetched(false);
    // };

    const handleGstChange = (e) => {
        let value = e.target.value.toUpperCase();
        if (!/^[A-Z0-9]{0,15}$/.test(value)) return;
        setFormState(prev => ({ ...prev, gstInno: value }));
        setGstError("");
        // Don't reset gstFetched here - only validate format
    };

    // const Fn_HandleGSTBlur = async () => {
    //     const gst = formState.gstInno.trim();
    //     if (gst.length !== 15) return;

    //     const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    //     if (!regex.test(gst)) {
    //         setGstError("Invalid GST format");
    //         return;
    //     }

    //     setGstLookupLoading(true);
    //     setGstError("");

    //     try {
    //         const { data } = await axios.get(`${API}/api/gst-lookup`, { params: { searchGstin: gst } });
    //         const d = data.data || {};

    //         setFormState(prev => ({
    //             ...prev,
    //             companyName: d.clientName || "",
    //             contactPerson: d.contactPerson || "",
    //             address: d.address || "",
    //             city: d.city || "",
    //             area: d.landMark || d.street || "",
    //             pincode: d.PinCode ? String(d.PinCode) : "",
    //             country: d.Country || "India",
    //             mobileno: d.mobileNo || "",
    //             emailId: d.emailId || ""
    //         }));

    //         if (d.city) {
    //             const cityObj = {
    //                 city: d.city,
    //                 state: d.state,
    //                 stateCode: d.stateCode || gst.slice(0, 2),
    //                 country: d.Country || "India"
    //             };
    //             setSelectedCity(cityObj);
    //             setCityQuery(d.city);
    //         }

    //         setGstFetched(true);
    //         setSnackbar({ open: true, message: "GST details fetched successfully", severity: "success" });
    //     } catch (err) {
    //         setGstError("Invalid or inactive GSTIN");
    //         setFormState(prev => ({
    //             ...prev,
    //             companyName: "", address: "", city: "", area: "", pincode: "", mobileno: "", emailId: ""
    //         }));
    //         setSelectedCity(null);
    //         setCityQuery("");
    //         setGstFetched(false);
    //     } finally {
    //         setGstLookupLoading(false);
    //     }
    // };

    const handleGstAutoFill = async () => {
        const gst = formState.gstInno.trim();
        if (gst.length !== 15) {
            setGstError("Please enter a valid 15-character GST No");
            return;
        }

        const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!regex.test(gst)) {
            setGstError("Invalid GST format");
            return;
        }

        setGstLookupLoading(true);
        setGstError("");

        try {
            const { data } = await axios.get(`${API}/api/gst-lookup`, { params: { searchGstin: gst } });
            const d = data.data || {};

            console.log("gst", d)

            setFormState(prev => ({
                ...prev,
                companyName: d.clientName || "",
                contactPerson: d.contactPerson || "",
                address: d.address || "",
                city: d.city || "",
                area: d.Area || d.landMark || d.street || '',
                pincode: d.PinCode ? String(d.PinCode) : "",
                country: d.Country || "India",
                mobileno: d.mobileNo || "",
                emailId: d.emailId || "",
                state: d.State,
                stateCode: d.stateCode || gst.slice(0, 2),
            }));

            if (d.city) {
                const cityObj = {
                    city: d.city,
                    state: d.state,
                    stateCode: d.stateCode || gst.slice(0, 2),
                    country: d.Country || "India"
                };
                setSelectedCity(cityObj);
                setCityQuery(d.city);
            }

            setGstFetched(true);
            setSnackbar({ open: true, message: "GST details fetched successfully", severity: "success" });
        } catch (err) {
            setGstError("Invalid or inactive GSTIN");
            setFormState(prev => ({
                ...prev,
                companyName: "", address: "", city: "", area: "", pincode: "", mobileno: "", emailId: "", state: "", stateCode: ""
            }));
            setSelectedCity(null);
            setCityQuery("");
            setGstFetched(false);
        } finally {
            setGstLookupLoading(false);
        }
    };

    const handleCitySelect = (cityObj) => {
        setSelectedCity(cityObj);
        setCityQuery(cityObj.city);
        setFormState(prev => ({
            ...prev,
            city: cityObj.city,
            state: cityObj.state,
            stateCode: cityObj.stateCode,
            country: cityObj.country || "India"
        }));
    };

    const validate = () => {
        if (!formState.companyName.trim() || !formState.contactPerson.trim() || !formState.emailId.trim()) {
            setFormError("Company Name, Contact Person and Email are required.");
            return false;
        }
        setFormError("");
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsSubmitting(true);
        setFormError("");

        const payload = {
            AppRegID,
            companyName: formState.companyName.trim(),
            address: formState.address.trim() || null,
            area: formState.area.trim() || null,
            city: formState.city.trim() || null,
            state: formState.state.trim() || null,
            stateCode: formState.stateCode.trim() || null,
            pincode: formState.pincode ? Number(formState.pincode) : null,
            country: formState.country.trim() || "India",
            contactPerson: formState.contactPerson.trim(),
            mobileno: formState.mobileno.trim(),
            website: formState.website.trim() || null,
            emailId: formState.emailId.trim(),
            currency: null,
            userName,
            password: pendingPassword,
            gstInno: formState.gstInno.trim() || null,
            adharno: formState.adharno.trim() || null,
            tanno: formState.tanno.trim() || null,
            panno: formState.panno.trim() || null,
            msmeno: formState.msmeno.trim() || null,
            cinno: formState.cinno.trim() || null,
            ielicno: formState.ielicno.trim() || null,
            postalAddress: formState.postalAddress.trim() || null,
            branchId: null,
            groupOfCompanyId: null,
            addUserId: Uid,
            EWBUserName: formState.EWBUserName,
            EWBPassword: formState.EWBPassword,
            EIUserName: formState.EIUserName,
            EIPassword: formState.EIPassword,
            BkName1: formState.BkName1 || null,
            BkBranch1: formState.BkBranch1 || null,
            BkAcNo1: formState.BkAcNo1 || null,
            BkIFSCCode1: formState.BkIFSCCode1 || null,
        };

        try {
            const res = await axios.post(`${API}/api/companyMaster`, payload);

            if (res.data.success) {
                localStorage.removeItem("pendingCompanyUser");

                const companyId = res.data.companyId;
                const companies = res.data.companies || [{ CompId: companyId, companyName: formState.companyName }];

                const updatedUser = {
                    ...currentUser,
                    CompId: companyId,
                    companyId: companyId
                };

                login(updatedUser, companies);

                setSnackbar({ open: true, message: "Company registered successfully!", severity: "success" });
                setTimeout(() => navigate("/NexonCRM"), 1500);
            } else {
                setFormError(res.data.message || "Registration failed");
                setSnackbar({ open: true, message: res.data.message || "Registration failed", severity: "error" });
            }
        } catch (err) {
            const msg = err.response?.data?.message || "Server error. Try again.";
            setFormError(msg);
            setSnackbar({ open: true, message: msg, severity: "error" });
        } finally {
            setIsSubmitting(false);
        }
    };

    const renderField = (label, name, required = false, multiline = false) => (
        <TextField
            fullWidth
            label={label}
            name={name}
            size="small"
            value={formState[name]}
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!errors[name]}
            helperText={errors[name] || ''}
            required={required}
            multiline={multiline}
            minRows={multiline ? 2.6 : undefined}
            sx={{
                ...(required ? requiredAsteriskStyle : {}),
                '& .MuiInputBase-root': {
                    height: multiline ? 'auto' : 40,
                    alignItems: 'center',
                    borderRadius: 2,
                },
                '& .MuiInputBase-input': { padding: '10px 14px' },
            }}
        />
    );

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 20 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Paper elevation={3} sx={{ p: 3, pt: 1, mt: 2, maxWidth: 1000, mx: 'auto', borderRadius: 3 }}>
            <Typography variant="h4" sx={{ mb: 1, textAlign: 'center' }}>
                Company Registration
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <form onSubmit={handleSubmit}>
                <Box display="flex" flexWrap="wrap" gap={3}>
                    {/* Left Column */}
                    <Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 2 }}>
                        {/* GST IN */}
                        {/* <TextField
                            label="GST IN"
                            name="gstInno"
                            value={formState.gstInno}
                            onChange={handleGstChange}
                            onBlur={Fn_HandleGSTBlur}
                            fullWidth
                            size="small"
                            inputProps={{ maxLength: 15 }}
                            error={!!gstError}
                            InputProps={{
                                endAdornment: formState.gstInno.length === 15 ? (
                                    gstLookupLoading ? (
                                        <InputAdornment position="end"><CircularProgress size={20} /></InputAdornment>
                                    ) : gstFetched ? (
                                        <InputAdornment position="end"><CheckCircleIcon sx={{ color: 'green' }} /></InputAdornment>
                                    ) : (
                                        <InputAdornment position="end"><CancelIcon sx={{ color: 'red' }} /></InputAdornment>
                                    )
                                ) : null,
                            }}
                            sx={{
                                '& .MuiInputBase-root': { height: 38, borderRadius: 2 },
                                '& .MuiInputBase-input': { padding: '10px 14px' },
                            }}
                        /> */}
                        <TextField
                            label="GST IN"
                            name="gstInno"
                            value={formState.gstInno}
                            onChange={handleGstChange}
                            fullWidth
                            size="small"
                            inputProps={{ maxLength: 15 }}
                            error={!!gstError}
                            helperText={gstError}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={handleGstAutoFill}
                                            disabled={gstLookupLoading || formState.gstInno.length !== 15}
                                            sx={{
                                                height: 32,
                                                mr: -1,
                                                fontSize: '0.75rem',
                                                textTransform: 'none',
                                                padding: '4px 8px'
                                            }}
                                        >
                                            {gstLookupLoading ? <CircularProgress size={16} sx={{ mr: 0.5 }} /> : 'Verify'}
                                        </Button>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                '& .MuiInputBase-root': { height: 38, borderRadius: 2 },
                                '& .MuiInputBase-input': { padding: '10px 14px' },
                            }}
                        />

                        {renderField("Company Name", "companyName", true)}
                        {renderField("Address", "address", false, true)}

                        {/* Area + Pincode */}
                        <Box display="flex" gap={2}>
                            <Box flex={1}>{renderField("Area", "area")}</Box>
                            <Box flex={1}>
                                <TextField
                                    label="Pincode"
                                    name="pincode"
                                    value={formState.pincode}
                                    required
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^\d{0,6}$/.test(val)) {
                                            setFormState(prev => ({ ...prev, pincode: val }));
                                        }
                                    }}
                                    fullWidth
                                    size="small"
                                    inputProps={{ maxLength: 6, inputMode: 'numeric' }}
                                    InputLabelProps={{
                                        sx: {
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': { height: 38, borderRadius: 2 },
                                        '& .MuiInputBase-input': { padding: '10px 14px' },
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* City + State + State Code */}
                        <Box display="flex" gap={1}>
                            <Box flex={1}>
                                <CitySearchInput
                                    value={selectedCity?.city || cityQuery}
                                    connectionString={connectionString}
                                    onSelectCity={handleCitySelect}
                                    onChangeQuery={(q) => {
                                        setCityQuery(q);
                                        setSelectedCity(null);
                                    }}
                                    fullWidth
                                    size="small"
                                    sx={{ '& .MuiInputBase-root': { height: 38 } }}
                                />
                            </Box>
                            <Box display="flex" flex={1} gap={1}>
                                <Box flex={0.6}>
                                    <FloatingLabelInput
                                        label="State"
                                        value={formState.state}
                                        disabled
                                        required
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ sx: requiredAsteriskStyle }}
                                        sx={{ '& .MuiInputBase-root': { height: 38 } }}
                                    />
                                </Box>
                                <Box flex={0.4}>
                                    <FloatingLabelInput
                                        label="State Code"
                                        value={formState.stateCode}
                                        disabled
                                        required
                                        fullWidth
                                        size="small"
                                        InputLabelProps={{ sx: requiredAsteriskStyle }}
                                        sx={{ '& .MuiInputBase-root': { height: 38 } }}
                                    />
                                </Box>
                            </Box>
                        </Box>

                        <TextField
                            fullWidth
                            label="Country"
                            name="country"
                            value={formState.country}
                            disabled
                            required
                            size="small"
                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                            sx={{
                                '& .MuiInputBase-root': {
                                    height: 38,
                                    borderRadius: 2,
                                },
                                '& .MuiInputBase-input': {
                                    padding: '10px 14px',
                                },
                            }}
                        />


                        {/* Contact Person + Mobile */}
                        <Box display="flex" flexDirection="column" gap={2}>
                            {renderField("Contact Person", "contactPerson", true)}
                            {renderField("Mobile Number", "mobileno", false)}
                        </Box>
                    </Box>

                    {/* Right Column */}
                    <Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 2 }}>
                        {renderField("Email ID", "emailId", true)}
                        {renderField("Website", "website")}
                        <Box display="flex" gap={1} width="100%">
                            <Box flex={1}>
                                {renderField('PAN No.', 'panNo', false, false, { xs: 12, md: 12 }, { sx: { mb: 1.3 } })}
                            </Box>
                            <Box flex={1}>
                                {renderField('Aadhar No.', 'aadharNo', false, false, { xs: 12, md: 12 }, { sx: { mb: 1.3 } })}
                            </Box>
                        </Box>
                        {renderField("TAN No", "tanno")}
                        {renderField("MSME No", "msmeno")}
                        {renderField("CIN No", "cinno")}
                        {renderField("I.E. No", "ielicno")}
                        {renderField("Postal Address", "postalAddress", false, true)}
                    </Box>
                </Box>

                {formError && (
                    <Typography color="error" sx={{ mt: 3, textAlign: 'center', fontWeight: 'bold' }}>
                        {formError}
                    </Typography>
                )}

                {/* E-Way Bill & E-Invoice Credentials Card */}
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Paper
                        elevation={2}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            border: '1px solid #e0e0e0'
                        }}
                    >

                        <Box display='flex' flexWrap='wrap' gap={2}>
                            {/* Left Section - E-Way Bill */}
                            <Box sx={{ flex: { xs: "100%", md: "48%" } }}>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        mb: 1.5,
                                        fontWeight: 600,
                                        color: 'text.secondary'
                                    }}
                                >
                                    E-Way Bill Details
                                </Typography>

                                <Box display="flex" flexDirection="column" gap={1.3}>
                                    <TextField
                                        fullWidth
                                        label="Username"
                                        name="EWBUserName"
                                        size="small"
                                        value={formState.EWBUserName || ''}
                                        onChange={handleChange}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: 38,
                                                borderRadius: 2,
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '10px 14px',
                                            },
                                        }}
                                    />

                                    <TextField
                                        fullWidth
                                        label="Password"
                                        name="EWBPassword"
                                        type={showPassword.eway ? "text" : "password"}
                                        size="small"
                                        value={formState.EWBPassword || ''}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => togglePassword("eway")}
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        {showPassword.eway ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: 38,
                                                borderRadius: 2,
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '10px 14px',
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>

                            {/* Right Section - E-Invoice */}
                            <Box sx={{ flex: { xs: "100%", md: "48%" } }}>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        mb: 1.5,
                                        fontWeight: 600,
                                        color: 'text.secondary'
                                    }}
                                >
                                    E-Invoice Details
                                </Typography>

                                <Box display="flex" flexDirection="column" gap={1.3}>
                                    <TextField
                                        fullWidth
                                        label="Username"
                                        name="EIUserName"
                                        size="small"
                                        value={formState.EIUserName || ''}
                                        onChange={handleChange}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: 38,
                                                borderRadius: 2,
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '10px 14px',
                                            },
                                        }}
                                    />

                                    <TextField
                                        fullWidth
                                        label="Password"
                                        name="EIPassword"
                                        type={showPassword.einvoice ? "text" : "password"}
                                        size="small"
                                        value={formState.EIPassword || ''}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => togglePassword("einvoice")}
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        {showPassword.einvoice ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                height: 38,
                                                borderRadius: 2,
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '10px 14px',
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Paper>
                </Box>

                {/* Bank Details */}
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 2, border: '1px solid #e0e0e0' }}>

                        <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: 'text.secondary' }}>
                            Bank Details
                        </Typography>

                        {/* Row 1 */}
                        <Box display="flex" gap={1.5} mb={1.5}>
                            <Box flex={1}>
                                {renderField('Bank Name', 'BkName1')}
                            </Box>
                            <Box flex={1}>
                                {renderField('Branch', 'BkBranch1')}
                            </Box>
                        </Box>

                        {/* Row 2 */}
                        <Box display="flex" gap={1.5}>
                            <Box flex={1}>
                                {renderField('Account No', 'BkAcNo1')}
                            </Box>
                            <Box flex={1}>
                                {renderField('IFSC Code', 'BkIFSCCode1')}
                            </Box>
                        </Box>

                    </Paper>
                </Box>

                <Box display="flex" justifyContent="center" mt={4}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                        startIcon={isSubmitting ? <CircularProgress size={18} /> : null}
                        sx={{ minWidth: 160, height: 44, borderRadius: 2 }}
                    >
                        Register
                    </Button>
                </Box>
            </form>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={5000}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
};

export default RegisterCompany;